var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},_vm._l((_vm.values),function(val){return _c('button',{key:val,class:[
      'btn',
      { 'btn-primary': _vm.value === val, 'btn-default': _vm.value !== val }
    ],attrs:{"type":"button"},on:{"click":function($event){return _vm.changeSelectVal(val)}}},[_vm._v("\n    "+_vm._s(val)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }